<template>
  <b-row>
    <b-col md="4">
      <label>Tarifa</label>
    </b-col>
    <b-col md="8">
      <b-form-input :value="nombreTarifa" disabled />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["nombreTarifa"]),
  },
};
</script>
